import Fondo from "../assets/fondoOne.png";

const SectionOne = () => {
    return (
        <div
            className="w-full h-[50vh] md:h-screen bg-cover bg-center bg-no-repeat flex items-start md:items-center justify-start"
            style={{ backgroundImage: `url(${Fondo})` }}
        >
            <div className="bg-black/60 md:bg-transparent h-full w-full md:w-1/2 text-white px-6 md:px-20 text-left flex flex-col justify-center gap-3">
                <h1 className="text-4xl md:text-6xl font-bold leading-tight">Un nuevo origen para tu negocio</h1>
                <p className="text-base md:text-lg">
                    Brindar estrategias integrales para la solución de problemas en empresas mexicanas e internacionales
                </p>
            </div>
        </div>
    );
};

export default SectionOne;
